import React from "react";
import Icon from "@ant-design/icons";

const icons = {
    urgent: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill="#F15B50"
                fillRule="evenodd"
                d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12 .75H4v-1.5h8z"
                clipRule="evenodd"
            ></path>
        </svg>
    ),
    highest: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill="#F15B50"
                fillRule="evenodd"
                d="m7.587 7.624-5.5 3.625.826 1.252L8 9.148l5.087 3.353.826-1.252-5.5-3.625a.75.75 0 0 0-.826 0m0-4.5-5.5 3.625L2.913 8 8 4.648l5.087 3.353.826-1.252-5.5-3.625a.75.75 0 0 0-.826 0"
                clipRule="evenodd"
            ></path>
        </svg>
    ),
    high: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill="#F15B50"
                fillRule="evenodd"
                d="m7.587 5.624-5.5 3.625.826 1.252L8 7.148l5.087 3.353.826-1.252-5.5-3.625a.75.75 0 0 0-.826 0"
                clipRule="evenodd"
            ></path>
        </svg>
    ),
    medium: () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill="#4688EC"
                fillRule="evenodd"
                d="M14 6.5H2V5h12zm0 4.5H2V9.5h12z"
                clipRule="evenodd"
            ></path>
        </svg>
    ),
    low: () => (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.5874 10.8762L2.0874 7.25122L2.91287 5.99878L8.00014 9.35175L13.0874 5.99878L13.9129 7.25122L8.41287 10.8762C8.16246 11.0413 7.83781 11.0413 7.5874 10.8762Z"
                fill="#4688EC"
            />
        </svg>
    ),
    lowest: () => (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.5874 8.37622L2.0874 4.75122L2.91287 3.49878L8.00014 6.85175L13.0874 3.49878L13.9129 4.75122L8.41287 8.37622C8.16246 8.54126 7.83781 8.54126 7.5874 8.37622ZM7.5874 12.8762L2.0874 9.25122L2.91287 7.99878L8.00014 11.3517L13.0874 7.99878L13.9129 9.25122L8.41287 12.8762C8.16246 13.0413 7.83781 13.0413 7.5874 12.8762Z"
                fill="#4688EC"
            />
        </svg>
    )
};
export const RankIcon = ({rankType}) => {
    return <Icon component={icons[rankType] || icons.medium} />;
};
